// extracted by mini-css-extract-plugin
export default {"title":"styles_title__NjvqD","timerContainer":"styles_timerContainer__zvnHS","timer":"styles_timer__jQDK+"};